import { Menu } from 'antd';
import { track } from '../../tracking';

export const OptionItem: React.FC<{
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
    label: string;
    leftIcon: JSX.Element;
    disabled?: boolean;
}> = ({ onClick, label, leftIcon, disabled }) => {
    return (
        <Menu.Item key={label} className="font-lato p-0">
            <button
                onClick={(e) => {
                    onClick(e);
                    e.stopPropagation();
                    track('OPTION_SELECT', { option: label });
                }}
                className="flex space-x-12 py-13 px-16 text-neutral-2 font-600 disabled:cursor-not-allowed disabled:opacity-60 w-full"
                disabled={disabled}
            >
                <div className="flex items-center">{leftIcon}</div>
                <p>{label}</p>
            </button>
        </Menu.Item>
    );
};
